export enum GaranttiTariffPlanEnum {
  silver = 'silver',
  gold = 'gold',
  custom = 'custom',
  platinum = 'platinum',
  black = 'black',
  blackplus = 'black_plus',
  silverCharges = 'silver__charges',
  goldCharges = 'gold__charges',
  customCharges = 'custom__charges',
  platinumCharges = 'platinum__charges',
  blackCharges = 'black__charges',
  blackplusCharges = 'black_plus__charges'
}
